const CURRENT_POLE = 'currentPole';

const setSelectedPole = (poleId: number) => {
  try {
    const lsValue = JSON.stringify(poleId);
    localStorage.setItem(CURRENT_POLE, lsValue);
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error);
  }
};

const getSelectedPole = (): number | undefined => {
  try {
    const lsValue: string | null = localStorage.getItem(CURRENT_POLE);
    if (!lsValue) {
      return;
    }

    const poleId: number = JSON.parse(lsValue) as number;
    if (poleId) {
      // You can easily check poleId_token expiration also
      return poleId;
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error);
  }
};

const removeSelectedPole = () => {
  try {
    localStorage.removeItem(CURRENT_POLE);
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error);
  }
};

export { getSelectedPole, setSelectedPole, removeSelectedPole, CURRENT_POLE };
